<template>
  <hr role="separator" class="border-neutral-20 my-1 w-full" />
</template>
